import React from 'react';

import { useIntl } from 'react-intl';

import { IconTitle, SectionTitle, SubHeading } from 'pages/order-confirmation/styled';
import { ServiceMode } from 'state/order';

import { getHeadingForServiceMode } from './utils';

const ServiceModeHeading = ({ serviceMode }: { serviceMode: ServiceMode }) => {
  const { formatMessage } = useIntl();
  const heading = getHeadingForServiceMode(serviceMode);

  return (
    heading && (
      <SubHeading focusable>
        <IconTitle variant={heading.icon} />
        <SectionTitle>{formatMessage({ id: heading.title })}</SectionTitle>
      </SubHeading>
    )
  );
};
export default ServiceModeHeading;
